import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    enabled: z.boolean(),
    reorderHsaPaymentMethodToTop: z.boolean(),
    canModifyCreditCardPaymentMethods: z.boolean(),
    sendGalePaymentInfoSubmittedEvents: z.boolean(),
    checkoutButtonsSkipShopPay: z.boolean(),
    /** Which storefront element interactions float HSA/FSA at checkout. */
    intentSignals: z.object({
      lmnStarted: z.boolean(),
      lmnCompleted: z.boolean(),
      pdpWidget: z.boolean(),
      cartWidget: z.boolean(),
    }),
  }),
};
